import {
  Dialog,
  DialogContentText,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';

interface Props {
  open: boolean;
  handleClose: () => void;
  createdLicense: string;
}

const LicenseOutputDialog = ({ open, handleClose, createdLicense }: Props) => {
  return (
    <Dialog fullWidth maxWidth={'sm'} open={open}>
      <DialogTitle>License</DialogTitle>
      <DialogContent>
        <DialogContentText>Clip to copy to clipboard</DialogContentText>

        <TextField
          variant='outlined'
          fullWidth
          multiline
          value={createdLicense}
          onClick={() => {
            navigator.clipboard.writeText(createdLicense);
          }}
        ></TextField>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={handleClose}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LicenseOutputDialog;
